import { createAction } from 'redux-act';

export const ScriptingUrlReceived = createAction('Scripting Url Received', (workItemId, url) => ({workItemId, url}));